// 识别能力
import request from "@/utils/request.js";
// let path = "/api";
const RecognitionCapability = {
  /**
   * @param page @type String 页码
   * @param pageSize @type String 条数
   */
  queryList: async (data) => {
    return await request("post", "/config-center/ability/list", data);
  },

  /**
   * 添加/修改用户
   * @param id @type String id  再新增的时候直接不传这个参数 在修改的时候再传
   * @param abilityName @type String   能力名称，例如：图像识别能力、语音识别能力等
   * @param innerCount @type Number   内部计数，可用于统计用途
   * @param delStatus @type Number   未删除为0   删除为1
   * @param createTime  @type String   创建时间
   */
  addOrUpDate: async (data) => {
    return await request("post", "/config-center/ability/add", data);
  },
  /**
   * 登录获取token
   * @param id @type String id
   */
  delAcList: async (data) => {
    return await request("get", "/config-center/ability/logic-del", data);
  },
};
export default RecognitionCapability;



// WEBPACK FOOTER //
// ./src/api/recognitionCapability.js